// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

/* eslint-disable */
import { ref, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import AppConstants from '@/appConstants'
import messageDialogHelper from '@/helpers/message-dialog-helper'
import messagesNotifyHelper from '@/helpers/messages-notify-helper'


export default function useImageLib() {
  // ------------------------------------------------
  // ORIGINS
  // ------------------------------------------------
  // const loadOrigins = () => {
  //   dropdownService.getAllOrigin(new URLSearchParams())
  //     .then(resp => {
  //       store.commit(`${AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME}/SET_ORIGINS`, resp);
  //       filterFields.value[filterFields.value.findIndex(item => item.id == 'filter-origin')].array = resp;
  //     })
  //     .catch(err => console.log(err));
  // }
  // loadOrigins();

  // ------------------------------------------------
  // DATA
  // ------------------------------------------------
  const data = ref([]);
  const totalRows = ref(0);
  const limit = ref(AppConstants.PAGINATOR_DEFAULT_LIMIT_MEDIA);
  const currentPage = ref(1);
  const displayAlert = ref(false);
  const image_type = ref(AppConstants.FILE_TYPE);

  const filterFields = ref([
    // { id: 'filter-origin', placeholder: 'Origem', type: 'list', inputType: '', model: 'origin', list: 'filter-list-origin', array: [] },
    { id: 'filter-tag', placeholder: 'Tag', type: 'text', inputType: 'text', model: 'tag' },
  ])

  let perfectScrollbarReachEnd = ref(false);
  const perfectScrollbarSettings = ref({
    maxScrollbarLength: 60,
    wheelSpeed: 0.3,
    swipeEasing: true,
  });

  // Use toast
  const toast = useToast()

  onMounted(() => { })

  // const selectedRegion = computed(() => store.state.calendar.selectedRegion)
  // --------------------------------------------------------------------------------------------------
  // COMPUTED
  // --------------------------------------------------------------------------------------------------
  const searchParams = computed(() => {
    const params = new URLSearchParams();
    // if (store.state[AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME].filters.origin) {
    //   params.append("origin", store.state[AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME].filters.origin.id);
    // }
    if (store.state[AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME]) {
      if (store.state[AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME].filter.length > 0) {
        params.append("filter", store.state[AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME].filter.join(','));
      }
    }
    if (store.state[AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME].extensions.length > 0) {
      // console.log('extensions: ', store.state[AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME].extensions);
      params.append("extensions", store.state[AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME].extensions.join(','));
    }

    params.append('page', currentPage.value);
    params.append('limit', limit.value);

    return params;
  });

  // --------------------------------------------------------------------------------------------------
  // FUNCTIONS
  // --------------------------------------------------------------------------------------------------
  const onEdit = () => {
    const formData = new FormData();
    formData.append("_id", imageSelected.value._id);
    formData.append("tags", imageSelected.value.tags);
    formData.append("copyright", imageSelected.value.copyright);
    formData.append("active", imageSelected.value.active);
    store
      .dispatch(`${AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME}/register`, {
        form: formData,
        params: new URLSearchParams()
      })
      .then(response => {
        console.log(response);
        messagesNotifyHelper.updatedRecordNotify();
        fetchImages();
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching images',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  };

  const fetchImages = (isPaginate = false) => {
    if (!isPaginate) {
      totalRows.value = 0;
      data.value = [];
      currentPage.value = 1;
      perfectScrollbarReachEnd.value = false;
    }
    // Fetch Events from API endpoint
    store
      .dispatch(`${AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME}/fetchImages`, {
        params: searchParams.value
      })
      .then(response => {
        totalRows.value = response.totalRows;
        if (isPaginate) {
          if (response.data.length > 0) {
            perfectScrollbarReachEnd.value = false;
          }
          data.value = data.value.concat(response.data);
        } else {
          data.value = response.data;
        }

        if (data.value.length == 0) {
          displayAlert.value = true;
        } else {
          displayAlert.value = false;
        }
        
        // self.$forceUpdate();
      })
      .catch(() => {
        if (data.value.length == 0) {
          displayAlert.value = true;
        } else {
          displayAlert.value = false;
        }
        // toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: 'Error fetching images',
        //     icon: 'AlertTriangleIcon',
        //     variant: 'danger',
        //   },
        // })
      })
  }

  

  const onFilter = (data) => {
    store.commit(`${AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME}/SET_FILTERS`, data);
    filterModel.value = data;
    // console.log("OnFilter: ", this.filter);
    fetchImages();
  }

  const onClearFilter = () => {
    store.commit(`${AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME}/SET_FILTERS`, []);
    fetchImages();
  }

  const onChangePage = (data) => {
    currentPage.value = data;
    fetchImages(true);
  }

  const onDelete = (data) => {
    messageDialogHelper.displayDeleteDataMessage(() => {
      console.log('delete: ', data);
      const params = new URLSearchParams();
      store
        .dispatch(`${AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME}/delete`, {
          id: data._id,
          params: params
        })
        .then(() => {
          console.log("deleted");
          imageSelected.value = {};
          fetchImages();
        });
    });

  }

  const scrollHandleToEnd = () => {
    // console.log(evt);
    if (!data.value.length) {
      return;
    }
    if (perfectScrollbarReachEnd.value) {
      return;
    }
    if (!perfectScrollbarReachEnd.value) {
      perfectScrollbarReachEnd.value = true;
      // console.log(evt);
      loadMorePage();
    }
  };

  const loadMorePage = () => {
    currentPage.value++;
    console.log("[loadMorePage]",currentPage.value);
    fetchImages(true);
  };

  const inputFilter = (val) => {
    // console.log('inputFilter: ', val);
    store.commit(`${AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME}/SET_FILTERS`, val);
    fetchImages();
  };

  const inputFilterExtensions = (val) => {
    console.log('inputFilterExtensions: ', val);
    store.commit(`${AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME}/SET_EXTENSIONS`, val);
    fetchImages();
  };

  // ------------------------------------------------------------------------

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const displayLoading = ref(false)

  const imageSelected = ref({})
  const isImageSelected = (data) => {
    return imageSelected.value._id == data._id;
  };
  const onSelectImage = (data) => {
    imageSelected.value = data;
  };
  const extensions = ref(AppConstants.MEDIA_DOCUMENT_TYPE);
  const filterExtension = ref([]);
  const filterModel = ref([]);

  const initFilter = (dataType = '') => {
    if (dataType) {
      filterExtension.value = [];
      if (dataType == 'thumb' || dataType == 'image') {
        const doc = AppConstants.MEDIA_DOCUMENT_TYPE.find(item => item.name == 'Imagem');
        filterExtension.value.push(doc);
        // if (filterExtension.value.findIndex(item => item.name == doc.name) < 0) {
        //   filterExtension.value.push(doc);
        // }
      }
      if (dataType == 'document') {
        const doc = AppConstants.MEDIA_DOCUMENT_TYPE.find(item => item.name == 'Documento');
        const spreadsheet = AppConstants.MEDIA_DOCUMENT_TYPE.find(item => item.name == 'Planilha');
        const pdf = AppConstants.MEDIA_DOCUMENT_TYPE.find(item => item.name == 'PDF');
        
        if (filterExtension.value.findIndex(item => item.name == doc.name) < 0) {
          filterExtension.value.push(doc);
        }
        if (filterExtension.value.findIndex(item => item.name == spreadsheet.name) < 0) {
          filterExtension.value.push(spreadsheet);
        }
        if (filterExtension.value.findIndex(item => item.name == pdf.name) < 0) {
          filterExtension.value.push(pdf);
        }
      }
      if (dataType == 'audio') {
        const doc = AppConstants.MEDIA_DOCUMENT_TYPE.find(item => item.name == 'Audio');
        filterExtension.value.push(doc);
        // if (filterExtension.value.findIndex(item => item.name == doc.name) < 0) {
        // }
      }
      else if (dataType == 'video') {
        const doc = AppConstants.MEDIA_DOCUMENT_TYPE.find(item => item.name == 'Video');
        filterExtension.value.push(doc);
        // if (filterExtension.value.findIndex(item => item.name == doc.name) < 0) {
        // }
      }
    } else {
      const ext = store.state[AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME].extensions;
      if (ext.length > 0) {
        ext.forEach(item => {
          const search = AppConstants.MEDIA_DOCUMENT_TYPE.find(m => m.values.findIndex(a => a == item) >= 0);
          if (filterExtension.value.findIndex(f => !f || f.name == search.name) < 0) {
            filterExtension.value.push(search);
          }
        });
        // filterExtension.value = AppConstants.MEDIA_DOCUMENT_TYPE.filter(item => item.values.findIndex(i => i == ext[0]) >= 0);
      }
    }
    
    filterModel.value = store.state[AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME].filter;
    store.commit(`${AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME}/SET_EXTENSIONS`, filterExtension.value);
  }
  return {
    data,
    totalRows,
    limit,
    filterFields,
    perfectScrollbarSettings,
    perfectScrollbarReachEnd,
    imageSelected,
    extensions,
    filterExtension,
    filterModel,
    displayAlert,
    image_type,

    // ----- Functions ----- //
    fetchImages,
    onFilter,
    onClearFilter,
    onChangePage,
    onDelete,
    scrollHandleToEnd,
    inputFilter,
    inputFilterExtensions,
    isImageSelected,
    onSelectImage,
    onEdit,
    initFilter,

    // ----- UI ----- //
    displayLoading,
  }
}
